import { render, staticRenderFns } from "./VpdServiceSummaryPanel.vue?vue&type=template&id=229d3e2a"
import script from "./VpdServiceSummaryPanel.vue?vue&type=script&lang=js"
export * from "./VpdServiceSummaryPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports